/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-20 14:58:06
 * @LastEditTime: 2019-08-23 19:00:21
 * @LastEditors: Please set LastEditors
 */
import Layout from '@/pages/Layout';
import index from '@/pages/index';

let IndexRouter = {
  path: '/',
  name: 'home',
  redirect: '/index'
};

let appRouter = [
  {
    path: '/index',
    name: 'index',
    component: index
  },
  {
    path: '/gsjs',
    name: 'gsjs',
    component: Layout,
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'gsjs_info/:id',
        name: 'gsjs_info',
        component: () => import('@/pages/gsjs')
      }
    ]
  },
  {
    path: '/gsxw',
    name: 'gsxw',
    component: Layout,
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'gsxw_info/:id',
        name: 'gsxw_info',
        component: () => import('@/pages/gsxw')
      }
    ]
  },
  {
    path: '/gsry',
    name: 'gsry',
    component: Layout,
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'gsry_info/:id',
        name: 'gsry_info',
        component: () => import('@/pages/gsry')
      }
    ]
  },
  {
    path: '/gcal',
    name: 'gcal',
    component: Layout,
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'gcal_info/:id',
        name: 'gcal_info',
        component: () => import('@/pages/gcal')
      }
    ]
  },
  {
    path: '/dj',
    name: 'dj',
    component: Layout,
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'dj_info/:id',
        name: 'dj_info',
        component: () => import('@/pages/dj')
      }
    ]
  },
  {
    path: '/rlzy',
    name: 'rlzy',
    component: Layout,
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'rlzy_info/:id',
        name: 'rlzy_info',
        component: () => import('@/pages/rlzy')
      }
    ]
  },
  {
    path: '/xxgk',
    name: 'xxgk',
    component: Layout,
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'xxgk_info/:id',
        name: 'xxgk_info',
        component: () => import('@/pages/xxgk')
      }
    ]
  },
  {
    path: '/about',
    name: 'about',
    component: Layout,
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'about_info/:id',
        name: 'about_info',
        component: () => import('@/pages/about')
      }
    ]
  },
  {
    path: '/news',
    name: 'news',
    component: Layout,
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'news_info/:id',
        name: 'news_info',
        component: () => import('@/pages/news')
      }
    ]
  },
  {
    path: '/gdjt',
    name: 'gdjt',
    component: Layout,
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'gdjt_info/:id',
        name: 'gdjt_info',
        component: () => import('@/pages/gdjt')
      }
    ]
  },
  {
    path: '/video',
    name: 'video',
    component: Layout,
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'video_info',
        name: 'video_info',
        component: () => import('@/pages/video')
      }
    ]
  },
  {
    path: '/product',
    name: 'product',
    component: Layout,
    children: [
      {
        path: 'product_info/:id',
        name: 'product_info',
        component: () => import('@/pages/product')
      }
    ]
  },
  {
    path: '/core',
    name: 'core',
    component: Layout,
    children: [
      {
        path: 'core_info/:id',
        name: 'core_info',
        component: () => import('@/pages/core')
      }
    ]
  },
  {
    path: '/human',
    name: 'human',
    component: Layout,
    children: [
      {
        path: 'human_info/:id',
        name: 'human_info',
        component: () => import('@/pages/human')
      }
    ]
  },
  {
    path: '/contact',
    name: 'contact',
    component: Layout,
    children: [
      {
        path: 'contact_info/:id',
        name: 'contact_info',
        component: () => import('@/pages/contact')
      }
    ]
  }
];
export const routers = [
  IndexRouter,
  ...appRouter
];



// WEBPACK FOOTER //
// ./src/router/routers.js